import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'
import { Can } from '../../../_contexts/AbilitiesContext'

export default function TodaysEventsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Events Scheduled Today.
        </h5>
        <div className='my-4'>
          When you have Events scheduled they will appear here.
        </div>

        <Can I="schedule" an="events">
          <Button as={Link} to='/events/schedule' variant='outline-primary' className="px-5">
            Schedule Event
          </Button>
        </Can>

      </Card.Body>
    </Card>
  )
}
